/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregConditionDto } from './AggregConditionDto';
import {
    AggregConditionDtoFromJSON,
    AggregConditionDtoFromJSONTyped,
    AggregConditionDtoToJSON,
} from './AggregConditionDto';
import type { CaseConditionDto } from './CaseConditionDto';
import {
    CaseConditionDtoFromJSON,
    CaseConditionDtoFromJSONTyped,
    CaseConditionDtoToJSON,
} from './CaseConditionDto';
import type { FlagConditionDto } from './FlagConditionDto';
import {
    FlagConditionDtoFromJSON,
    FlagConditionDtoFromJSONTyped,
    FlagConditionDtoToJSON,
} from './FlagConditionDto';
import type { GroupSelectorDto } from './GroupSelectorDto';
import {
    GroupSelectorDtoFromJSON,
    GroupSelectorDtoFromJSONTyped,
    GroupSelectorDtoToJSON,
} from './GroupSelectorDto';

/**
 * 
 * @export
 * @interface RuleCreateDto
 */
export interface RuleCreateDto {
    /**
     * 
     * @type {string}
     * @memberof RuleCreateDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RuleCreateDto
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof RuleCreateDto
     */
    orderValue?: number;
    /**
     * 
     * @type {Array<FlagConditionDto>}
     * @memberof RuleCreateDto
     */
    flagConditions?: Array<FlagConditionDto>;
    /**
     * 
     * @type {Array<GroupSelectorDto>}
     * @memberof RuleCreateDto
     */
    groupSelectors: Array<GroupSelectorDto>;
    /**
     * 
     * @type {Array<CaseConditionDto>}
     * @memberof RuleCreateDto
     */
    caseConditions: Array<CaseConditionDto>;
    /**
     * 
     * @type {Array<AggregConditionDto>}
     * @memberof RuleCreateDto
     */
    aggregConditions: Array<AggregConditionDto>;
    /**
     * 
     * @type {object}
     * @memberof RuleCreateDto
     */
    actions: object;
    /**
     * 
     * @type {Date}
     * @memberof RuleCreateDto
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof RuleCreateDto
     */
    updated?: Date;
}

/**
 * Check if a given object implements the RuleCreateDto interface.
 */
export function instanceOfRuleCreateDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "groupSelectors" in value;
    isInstance = isInstance && "caseConditions" in value;
    isInstance = isInstance && "aggregConditions" in value;
    isInstance = isInstance && "actions" in value;

    return isInstance;
}

export function RuleCreateDtoFromJSON(json: any): RuleCreateDto {
    return RuleCreateDtoFromJSONTyped(json, false);
}

export function RuleCreateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuleCreateDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'orderValue': !exists(json, 'orderValue') ? undefined : json['orderValue'],
        'flagConditions': !exists(json, 'flagConditions') ? undefined : ((json['flagConditions'] as Array<any>).map(FlagConditionDtoFromJSON)),
        'groupSelectors': ((json['groupSelectors'] as Array<any>).map(GroupSelectorDtoFromJSON)),
        'caseConditions': ((json['caseConditions'] as Array<any>).map(CaseConditionDtoFromJSON)),
        'aggregConditions': ((json['aggregConditions'] as Array<any>).map(AggregConditionDtoFromJSON)),
        'actions': json['actions'],
        'created': !exists(json, 'created') ? undefined : (new Date(json['created'])),
        'updated': !exists(json, 'updated') ? undefined : (new Date(json['updated'])),
    };
}

export function RuleCreateDtoToJSON(value?: RuleCreateDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
        'orderValue': value.orderValue,
        'flagConditions': value.flagConditions === undefined ? undefined : ((value.flagConditions as Array<any>).map(FlagConditionDtoToJSON)),
        'groupSelectors': ((value.groupSelectors as Array<any>).map(GroupSelectorDtoToJSON)),
        'caseConditions': ((value.caseConditions as Array<any>).map(CaseConditionDtoToJSON)),
        'aggregConditions': ((value.aggregConditions as Array<any>).map(AggregConditionDtoToJSON)),
        'actions': value.actions,
        'created': value.created === undefined ? undefined : (value.created.toISOString()),
        'updated': value.updated === undefined ? undefined : (value.updated.toISOString()),
    };
}

